__webpack_public_path__ = "http://dev.local:8080/assets/";

import "../scss/application.scss";
import {onLoading} from "./_modules/website";
import {loadPage} from "./_modules/home";
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

import 'flickity/css/flickity.css';

var Flickity = require('flickity');

onLoading();
document.addEventListener("DOMContentLoaded", () => {
    onLoading();
    loadPage();
    Alpine.plugin(collapse);
    window.Alpine = Alpine;
    Alpine.start();

    gsap.registerPlugin(ScrollTrigger)
    gsap.registerPlugin(ScrollToPlugin);

    window.addEventListener("resize", () => {
        ScrollTrigger.refresh();
    });


    gsap.utils.toArray(".slide:not(:last-of-type)").forEach(item => {
        gsap.to(item, {
            scrollTrigger: {
                scroller: "main",
                trigger: item,
                start: "top 1%",
                end: "center 45%",
                onEnter: () => {
                    const textElement = item.querySelector('.slide-text');
                    textElement.style.opacity = 1;
                },
                onEnterBack: () => {
                    const textElement = item.querySelector('.slide-text');
                    textElement.style.opacity = 1;
                },
                onLeave: () => {
                    const textElement = item.querySelector('.slide-text');
                    textElement.style.opacity = 0;

                },
                onLeaveBack: () => {
                    const textElement = item.querySelector('.slide-text');
                    textElement.style.opacity = 0;
                },
            },
        });
    });

    const carousel = document.querySelector('.carousel');
    let flkty = null; // Stocke l'instance de Flickity
    function initFlickity() {
        const carousel = document.querySelector('.carousel');

        if (carousel && window.innerWidth > 1024) {
            if (!flkty) { // Vérifie si Flickity n'est pas déjà initialisé
                flkty = new Flickity('.carousel', {
                    cellAlign: 'center',
                    contain: true,
                    lazyLoad: 2,
                    wrapAround: true,
                    pageDots: false,
                    arrowShape: 'M57.99 74.41L32.81 49.23L57.99 24.04L58.88 24.92L34.58 49.23L58.88 73.53L57.99 74.41z',
                });
            }
        } else if (flkty) {
            destroyFlickity();
        }
    }
    function destroyFlickity() {
        if (flkty) {
            flkty.destroy();
            flkty = null; // Réinitialise la variable
        }
    }
    window.addEventListener('resize', initFlickity);
    initFlickity();

    const exhibitors = document.querySelectorAll(".exhibitor");
    const coverContainer = document.querySelector(".cover-image");

    if (exhibitors && coverContainer) {
        exhibitors.forEach((elem) => {
            elem.addEventListener('mouseenter', function () {
                const cover = elem.querySelector('.cover').innerHTML;
                coverContainer.innerHTML = cover;
            });
            elem.addEventListener('mouseleave', function () {
                coverContainer.innerHTML = null;
            });
        });
    }


    const subMenuLinks = document.querySelectorAll(".sub-menu a");
    const scrollContainer = document.querySelector('.scroll-snap-wrapper');

    subMenuLinks?.forEach((elem) => {
        elem.addEventListener('click', function (e) {
            e.preventDefault();
            const target = elem.getAttribute('href');
            gsap.to(scrollContainer, {duration: 0.6, scrollTo: {y: target, offsetY: 0}});
        });
    });

    const sections = document.querySelectorAll('.scroll-snap-wrapper > *'); // Toutes les sections dans le conteneur

// Crée un ScrollTrigger pour chaque section
    sections?.forEach((section) => {
        const link = document.querySelector(`.sub-menu a[href="#${section.id}"]`);

        if (link) {
            ScrollTrigger.create({
                scroller: scrollContainer,
                trigger: section, // Section à observer
                start: "top 10%", // Lorsque le haut de la section atteint le milieu du viewport// Lorsque le bas de la section quitte le milieu du viewport
                onEnter: () => {
                    subMenuLinks.forEach((link) => link.classList.remove('active')); // Supprime 'active' de tous les liens
                    link.classList.add('active'); // Ajoute 'active' au lien correspondant
                },
                onLeave: () => {
                    subMenuLinks.forEach((link) => link.classList.remove('active')); // Supprime 'active' si on quitte en remontant
                    link.classList.add('active'); // Ajoute 'active' au lien correspondant
                },
                onEnterBack: () => {
                    subMenuLinks.forEach((link) => link.classList.remove('active')); // Supprime 'active' de tous les liens
                    link.classList.add('active'); // Ajoute 'active' au lien correspondant
                },
                onLeaveBack: () => {
                    subMenuLinks.forEach((link) => link.classList.remove('active')); // Supprime 'active' si on quitte en remontant
                    link.classList.add('active'); // Ajoute 'active' au lien correspondant
                }
            });
        }
    });

    window.dispatchEvent(new Event('resize'));

    /* const container = document.querySelector('.scroll-wrapper');
      container?.addEventListener('wheel', function (event) {
         document.querySelector('.scroll-snap-wrapper').style.overflow = 'hidden';
          // Prevent the default vertical scrolling
          // Scroll horizontally based on the vertical mouse wheel movement
          container.scrollLeft += event.deltaY; // Use deltaY to scroll horizontally

        if (container.scrollLeft <= 0) {
          document.querySelector('.scroll-snap-wrapper').style.overflow = null;
        }
      });*/


    /*document.querySelectorAll('.slide').forEach(slide => {
      const textElement = slide.querySelector('.slide-text');

      if (textElement) {
        // Ajoute une animation ScrollTrigger pour chaque "slide-text"
        gsap.fromTo(
            textElement,
            { opacity: 0, y: 50 }, // Départ (invisible et légèrement en bas)
            {
              opacity: 1,
              y: 0,
              duration: 0.5, // Durée de l'animation
              ease: "power2.out",
              scrollTrigger: {
                scroller: 'main',
                trigger: slide,
                start: "top 50%", // Lorsque le haut de "slide" atteint le milieu de l'écran
                end: "top top",
                toggleActions: "play none play reverse", // Joue l'animation à l'entrée et l'inverse à la sortie
              }
            }
        );
      }
    });
  */
});